import { render, staticRenderFns } from "./CardCars.vue?vue&type=template&id=81c036be&scoped=true"
import script from "./CardCars.vue?vue&type=script&lang=js"
export * from "./CardCars.vue?vue&type=script&lang=js"
import style0 from "./CardCars.vue?vue&type=style&index=0&id=81c036be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c036be",
  null
  
)

export default component.exports